import React from 'react';
import EditPanel from '../panel/editPanel';
import AddPanel from '../panel/addPanel';
import SearchPanel from '../panel/searchPanel';
import AdvancedSearchPanel from '../panel/advancedsearchpanel';
import TogglePanelStore from '../panel/store/togglePanelStore';
import Modal from 'react-modal';
import classNames from 'classnames';
import AppearPanel from '../panel/appearPanel';
import ViewPagerPanel from '../panel/viewPagerPanel';
import WelcomeBlock from './welcomeBlock';
const $ = jQuery;

class AddBlock extends React.Component {
  constructor(props) {
    super(props);
    this.isEditable = API.isEditable ? true : false;
    this.state = {
      isOpen: false,
      panelType: 'addblock',
      editUid: null,
      childUid: null,
      successShow: false,
      welcomeShow: true,
    };
    this.reactiveSiteTour = 'false';
    this.handleAddComponent = this.handleAddComponent.bind(this);
    this.handleToggleEditPanel = this.handleToggleEditPanel.bind(this);
    this.handleApperance = this.handleApperance.bind(this);
    this.handleViewPager = this.handleViewPager.bind(this);
    this.loadProps = this.loadProps.bind(this);
    this.handleReactiveSiteTour = this.handleReactiveSiteTour.bind(this);
    this.closeModal = this.closeModal.bind(this);
    TogglePanelStore.listen(this.handleToggleEditPanel);
  }
  componentDidMount() {
    if (localStorage.getItem('reactiveSiteTour')) {
      this.reactiveSiteTour = localStorage.getItem('reactiveSiteTour');
    } else {
      localStorage.setItem('reactiveSiteTour', 'false');
    }
    if (this.reactiveSiteTour === 'false' && this.state.isEditable) {
      this.handleReactiveSiteTour();
    }
    this.loadProps(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.loadProps(nextProps);
  }
  loadProps(props) {
    let welcomeShow = null;
    if (props.allLayout.length) {
      welcomeShow = false;
    } else {
      welcomeShow = true;
    }
    this.setState({ welcomeShow, isEditable: props.isEditable });
  }
  openModal() {
    this.setState({ modalIsOpen: true, isOpen: false });
  }
  closeModal() {
    this.setState({ modalIsOpen: false });
    setTimeout(() => {
      this.setState({ successShow: false });
    }, 300);
  }
  handleAddComponent() {
    this.setState({ modalIsOpen: true, 'panelType': 'addblock' });
  }

  handleApperance() {
    this.setState({ modalIsOpen: true, 'panelType': 'appear' });
  }

  handleViewPager(event) {
    event.preventDefault();
    this.setState({ modalIsOpen: true, 'panelType': 'viewPager' });
  }

  handleReactiveSiteTour() {
    this.setState({ modalIsOpen: true, 'panelType': 'viewPager' });
  }

  successMessage() {
    this.setState({ successShow: true });
  }
  // toggling it for hide purpose of course :)
  handleToggleEditPanel(command, panelType, shortcodeKey, uid, childUid) {
    if (panelType === 'search') {
      this.setState({ modalIsOpen: !this.state.modalIsOpen });
    }
    // it has some place for improvements
    if (this.props.shortcodeKey === shortcodeKey) {
      if (panelType === '') {
        this.setState({ isOpen: false, modalIsOpen: false });
      } else {
        if (panelType !== this.state.panelType) {
          this.setState({ isOpen: true, panelType, editUid: uid, childUid });
        } else {
          this.setState({ isOpen: command, panelType, editUid: uid, childUid });
        }
      }
    } else {
      this.setState({ isOpen: false });
    }
    if (panelType === 'advancedsearch') {
      this.setState({ modalIsOpen: !this.state.modalIsOpen });
    }
  }
  render() {
    const addClass = this.state.isOpen ? 'active' : '';
    const successMessage = classNames({
      'modal-overlay-content': true,
      'active': this.state.successShow,
    });
    let showModal;

    switch (this.state.panelType) {
      case 'addblock' :
        showModal = <AddPanel {...this.props} onClickedPanel={this.successMessage.bind(this)}/>; break;
      case 'search' :
        showModal = <SearchPanel {...this.props} onClickedPanel={this.successMessage.bind(this)} panelType={this.state.panelType} uid={this.state.editUid} childUid={this.state.childUid} />; break;
      case 'advancedsearch' :
        showModal = <AdvancedSearchPanel {...this.props} onClickedPanel={this.successMessage.bind(this)} panelType={this.state.panelType} uid={this.state.editUid} childUid={this.state.childUid}/>; break;
      case 'appear':
        showModal = <AppearPanel {...this.props} onClickedPanel={this.successMessage.bind(this)}/>; break;
      case 'viewPager':
        showModal = <ViewPagerPanel {...this.props} onCloseModal = {this.closeModal} />; break;
      default : break;
    }
    return (<div>
        <Modal
          className="Modal__Bootstrap modal-dialog"
          portalClassName="rq-modal-wrapper"
          closeTimeoutMS={150}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldCloseOnOverlayClick={false}
        >
        <div className="modal-close-content">
          <button className="modal-close" onClick={this.closeModal}><i className="ion-android-close"></i></button>
        </div>
        <div className="modal-component">
          <div className={successMessage}>
            <div className="reactive-alert showSweetAlert visible">
              <div className="sa-icon sa-success animate">
                <span className="sa-line sa-tip animateSuccessTip"></span>
                <span className="sa-line sa-long animateSuccessLong"></span>
                <div className="sa-placeholder"></div>
                <div className="sa-fix"></div>
              </div>
                <p>Successfully Added!</p>
              <div className="sa-confirm-button-container">
                  <button className="hide-button" onClick={this.closeModal}>Close</button>
                </div>
            </div>
          </div>
          {showModal}
        </div>
      </Modal>

      {this.state.isEditable && <a className="rq-help-link" href="#" onClick={this.handleViewPager}><span>{API.LANG.REACTIVE_HELP_BUTTON}</span></a> }
      {this.state.isEditable && <div className="flex-row addblock-button-content">
        <div className="flex-xs-12">
          <div className="flex-row">
            <div className="addblock-button flex-md-6 flex-sm-6 flex-xs-6" data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_ADD_BLOCK} onClick={this.handleAddComponent}><i className="fa fa-paw" aria-hidden="true"></i></div>
            <div className="addblock-button flex-md-6 flex-sm-6 flex-xs-6" data-toggle="tooltip" data-placement="top" title={API.LANG.TOOL_TIP_SETTINGS} style={{ background: '#E6E6E6' }} onClick={this.handleApperance}>
              <i className="fa fa-bolt" aria-hidden="true"></i>
            </div>
          </div>
          {this.state.isEditable && this.state.welcomeShow ? <WelcomeBlock {...this.props}/> : ''}
        </div>

      </div> }

      {
        this.state.panelType !== 'search' && this.state.panelType !== 'addblock' && this.state.panelType !== 'viewPager' && this.state.panelType !== 'advancedsearch' && this.state.panelType !== 'appear' ?
          <EditPanel {...this.props} addClass={addClass} panelType={this.state.panelType} uid={this.state.editUid} childUid={this.state.childUid} /> : null
      }

    </div>);
  }
}

AddBlock.propTypes = {
  'shortcodeKey': React.PropTypes.number,
};

export default AddBlock;



// WEBPACK FOOTER //
// ./assets/src/frontend/builder/addblock.js